var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('users-form',{attrs:{"user":_vm.user,"errors":_vm.errors},on:{"update:user":function($event){_vm.user=$event}}})],1):_c('loading-content')
}
var staticRenderFns = []

export { render, staticRenderFns }